import React, {useMemo} from "react";
import {compose} from "redux";
import {translate} from "react-i18next";
import {Button, Col, Form, Input, Modal, Row} from "antd";
import {GUTTER_SM, MODAL_WIDTH_MD} from "../../../../styles/constants";
import EnhancedModal from "../../../../components/enhanced-modal";
import {connect} from "react-redux";
import PerfInput from "../../../../components/perf-input";
import {isFixedColInvalid} from "./components/utils";
import {addAliasColsDatasetBuilder} from "./actions";

const mapStateToProps = state => {
    return {
        aliasCols: state.scenes.mappingHandler.datasetBuilder.unionModalProps.aliasCols,
    }
};

const mapDispatchToProps = dispatch => ({
    addNewFixedValCol: (col) => dispatch(addAliasColsDatasetBuilder([col])),
});

const mapPropsToFields = () => {
    return {
        colID: Form.createFormField({value: null}),
        colValue: Form.createFormField({value: null}),
    }
};

const checkAndAddFixedCol = (fixedCol, allIDs, action, t, onModalHide) => {
    if (!isFixedColInvalid(fixedCol, allIDs, t)) {
        action({...fixedCol, fixedValue: true});
        onModalHide();
    } else {
        Modal.warning({
            title: t('commons.alerts.invalidForm.title'),
            content: t('commons.alerts.invalidForm.content')
        });
    }
}

const FixedColModal = ({
                           isModalVisible,
                           onModalHide,
                           t,
                           form,
                           aliasCols,
                           addNewFixedValCol
                       }) => {
    const allIDs = useMemo(() => aliasCols.map(item => item.colID), [aliasCols]);
    return (
        <EnhancedModal
            visible={isModalVisible}
            onCancel={onModalHide}
            title={t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.title')}
            width={MODAL_WIDTH_MD}
            footer={<Row type="flex" justify="end" align="middle" gutter={GUTTER_SM}>
                <Col>
                    <Button
                        onClick={onModalHide}
                    >
                        {t('commons.buttons.cancel.title')}
                    </Button>
                </Col>
                <Col>
                    <Button
                        type="primary"
                        onClick={() => checkAndAddFixedCol(form.getFieldsValue(), allIDs, addNewFixedValCol, t, onModalHide)}
                    >
                        {t('commons.buttons.create.title')}
                    </Button>
                </Col>
            </Row>}
        >
            <Form>
                <Form.Item
                    label={t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.fields.colID')}
                    className="ant-form-item-required"
                    required
                    validateStatus={allIDs.includes(form.getFieldValue("colID")) ? "warning" : null}
                    help={allIDs.includes(form.getFieldValue("colID")) ? t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.errors.colIDShouldBeUnique') : null}

                >
                    {form.getFieldDecorator('colID')(
                        <PerfInput
                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                            Component={Input}
                            title={form.getFieldValue('colID')}
                        />
                    )}
                </Form.Item>
                <Form.Item
                    label={t('scenes.mappingHandler.DatasetBuilder.wizard.step.fixedValueColModal.fields.value')}
                    className="ant-form-item-required"
                    required

                >
                    {form.getFieldDecorator('colValue')(
                        <PerfInput
                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                            Component={Input}
                            title={form.getFieldValue('colValue')}
                        />
                    )}
                </Form.Item>
            </Form>
        </EnhancedModal>
    )
}

export default compose(
    translate(),
    connect(mapStateToProps, mapDispatchToProps),
    Form.create({
        mapPropsToFields,
    })
)(FixedColModal);